import React from "react";

import { Checkbox, DateRange } from "components/form_components/Inputs";
import { BidFilterContentProps, StyledFilterContent } from "./utils";

function SubmissionDateFilterContent({ control }: BidFilterContentProps) {
  return (
    <StyledFilterContent aria-label="Submission date filter">
      <DateRange name="submissionDate.filter" control={control} label="" />
      <Checkbox
        label=""
        name="submissionDate.hideNulls"
        control={control}
        fieldLabel="Hide bids that don't have a submission date"
      />
    </StyledFilterContent>
  );
}

export default SubmissionDateFilterContent;
